import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import Card from "../../atoms/Card";
import IconButton from "../../atoms/IconButton";
import CardHeader from "../../atoms/CardHeader";
import EstadoDeCuentaTable from "../../organisms/inmueble/inmuebleDocsTables/EstadoDeCuentaTable";
import { useSession } from "../../../context/SessionContext";
import { GET_EDO_CTA_BY_USER } from "../../../api/apiEdoCuenta";
import { ordenarYFiltrarEdoCta } from "../../../utils/edoCtaUtils";
import Breadcrumb from "../../molecules/Breadcrumb";
import { getInmobiliaria } from "../../../utils/getInmobiliaria";
import { GET_INMUEBLE_ID } from "../../../api/apiInmuebles";

const InmuebleEdoCuentaTemplate = () => {
    const { idUser, id, im } = useParams();
    const { user } = useSession();
    const [inmueble, setInmueble] = useState();
    const [loading, setLoading] = useState();
    const [edoCuenta, setEdoCuenta] = useState([]);

    const getEdoCuenta = useCallback ( async () => {
        setLoading(true);

        try {
            const edoCuentaData = await GET_EDO_CTA_BY_USER(Number(im));
            let temporalEdoCta;
            if (user?.role === "Resident") {
                temporalEdoCta = ordenarYFiltrarEdoCta(
                    edoCuentaData.filter(item => item.userId === user.id),
                    "Resident"
                );
            } else if (user?.role === "GeneralAdmin") {
                temporalEdoCta = ordenarYFiltrarEdoCta(edoCuentaData, "Admin");
            };

            setEdoCuenta(temporalEdoCta);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [im, user]);

    const getInmueble = useCallback ( async () => {
        if (!im) return;
        try {
                const inmuebleData = await GET_INMUEBLE_ID(Number(im));
                setInmueble(inmuebleData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }, [im]);

    useEffect(() => {
        getEdoCuenta();
    }, [getEdoCuenta]);

    useEffect(() => {
        if (!im) return;
        getInmueble();
    },[getInmueble, im]);


    const linksAdmin = [
        { label: "Inmobiliarias", to: "/inmobiliarias" },
        { label: getInmobiliaria(id), to: `/inmobiliarias/${id}` },
        { label: inmueble?.name, to: `/inmobiliarias/${id}/${im}` },
        { label: "Estado de cuenta", to: null },
    ];

    const linksUser = [
        { label: inmueble?.name, to: `/${idUser}/${im}` },
        { label: "Estado de cuenta", to: null },
    ];

    return (
        <div className="flex flex-col gap-4">
            <CardHeader
                          left={
                            <Breadcrumb
                              items={user?.role === "Resident" ? linksUser : linksAdmin}
                            />
                          }
                right={<IconButton icon={FaPlus} bgColor="bg-white" disabled/>}
            />
            <Card>
                <EstadoDeCuentaTable data={edoCuenta} loading={loading} refetch={getEdoCuenta}/>
            </Card>
        </div>
    );
};

export default InmuebleEdoCuentaTemplate;